import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import BottomNav from "./components/layout/BottomNav";
import Wishlist from "./components/wishlist/Wishlist";
import Address from "./components/address/Address";
import Orders from "./components/order/Orders";
// import Cart from "./components/cart/Cart";
import CartPage from "./pages/CartPage";
import ProductDetails from "./components/product/ProductDetails";
import Slider from "./components/home/CategorySlider";
import PrivateRoute from "./routes/PrivateRoute";
import Home from "./pages/Home";
import Payment from "./pages/PaymentScreen";
import Account from "./pages/Account";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import ForgotPass from "./components/auth/ForgetPass";
import NotFound from "./pages/NotFound";
import OrderSuccess from "./pages/OrderSuccess";
import ViewAllProducts from "./components/viewall/ViewallProducts";
// import Loader from "./loader/Loader";

function App() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="Account" element={<Account />} />
        <Route path="Payment" element={<Payment />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPass />} />
        <Route path="/address" element={<Address />} />
        <Route path="/OrderSuccess" element={<OrderSuccess />} />
        <Route path="/Orders" element={<Orders />} />
        <Route path="/Slider" element={<Slider />} />
        <Route path="/product-details/:id" element={<ProductDetails />} />
        <Route path="/view-all/:categoryId" element={<ViewAllProducts />} />

        {/* Private Route */}
        <Route
          path="/cart"
          element={
            <PrivateRoute>
              <CartPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/wishlist"
          element={
            <PrivateRoute>
              <Wishlist />
            </PrivateRoute>
          }
        />

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <BottomNav />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
